import { useEffect } from 'react';

/** Toggle a class on <body> — the stylesheet keys overlays (drawer, sheet, ask) off body classes. */
export function useBodyClass(name: string, on: boolean) {
  useEffect(() => {
    document.body.classList.toggle(name, on);
    return () => document.body.classList.remove(name);
  }, [name, on]);
}
